<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/threeCard'}">承诺卡</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.key ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="110px"
                    class="demo-ruleForm"
                    style="width:60%;margin:0 auto"
                    size="small"
            >
                <el-form-item label="名称" prop="name">
                    <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="编号" prop="number">
                    <el-input v-model="ruleForm.number"></el-input>
                </el-form-item>
                <el-form-item label-width="0">
                    <el-col :span="12">
                        <el-form-item label="部门/岗位" prop="value">
                            <el-cascader v-model="ruleForm.value" :options="options" @change="handleChange"
                                         style="width: 100%"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="员工" prop="empId">
                            <el-select v-model="ruleForm.empId" placeholder="请选择" style="width: 100%"
                                       @change="$forceUpdate()">
                                <el-option
                                        v-for="item in workerList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label="部门领导" prop="leaderEmpId">
                    <el-select v-model="ruleForm.leaderEmpId" placeholder="请选择" style="width: 100%"
                               @change="$forceUpdate()">
                        <el-option
                                v-for="item in leaderEmpList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="承诺事项内容" prop="content">
                    <el-input type="textarea" v-model="ruleForm.content" :rows="4"/>
                </el-form-item>
                <el-form-item label="承诺时间" prop="commitmentDate">
                    <el-date-picker
                            v-model="ruleForm.commitmentDate"
                            type="date"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="附件" prop="fileName">
                    <el-upload
                            class="upload-demo"
                            action="/v1/lawsRegulations/uploadFile"
                            :on-remove="handleRemove"
                            :limit="1"
                            :on-change="uploadChange"
                            :on-exceed="handleExceed"
                            :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <el-button type="primary" class="addBtn" @click="submitForm('ruleForm')">确定</el-button>
        </div>
    </div>
</template>

<script>
    import {getDepartUser, getEmpListByJobId, addPromiseCard, updatePromiseCard} from "@/api/processManager";

    export default {
        data() {
            return {
                isAdd: true,
                ruleForm: {},
                rules: {
                    name: [{required: true, message: "请输入名称", trigger: "blur"}],
                    value: [{required: true, message: "请选择部门岗位", trigger: "blur"}],
                    number: [{required: true, message: "请输入编号", trigger: "blur"}],
                    empId: [{required: true, message: "请选择员工", trigger: "blur"}],
                    leaderEmpId: [{required: true, message: "请选择部门领导", trigger: "blur"}],
                    content: [{required: true, message: "请输入承诺事项内容", trigger: "blur"}],
                    commitmentDate: [{required: true, message: "请选择承诺时间", trigger: "blur"}],
                },
                // 岗位和部门的数组
                options: [],
                // 部门下面人员的数组（部门领导）
                leaderEmpList: [],
                // 岗位下面的人员数组
                workerList: [],
                getObj: {},
                fileList: [],
            };
        },
        methods: {
            handleChange(value) {
                console.log(value);
                if (this.ruleForm.depId != value[0]) {
                    this.ruleForm.depId = value[0]
                    this.leaderEmpList = [];
                    this.ruleForm.leaderEmpId = "";
                    // 获取部门领导
                    getDepartUser({demId: value[0]}).then(res => {
                        this.leaderEmpList = res.body.data;
                    });
                }
                this.ruleForm.jobId = value[1]
                // 获取岗位下面的人员
                getEmpListByJobId({jobId: value[1]}).then(res => {
                    this.workerList = res.body.data
                    this.ruleForm.empId = ''
                })
            },
            //获取部门 信息
            getAllEmpInfo() {
                this.componentsMoudel.httpRequest
                    .getRequestHander(this.componentsMoudel.getData("urls").getAllEmplotee)
                    .openLoad()
                    .startGet()
                    .then(res => {
                        res.body.data.forEach(item => {
                            let obj = {value: item.id, label: item.name, children: []};
                            item.jobVos.forEach((items, indexs) => {
                                let newObj = {value: items.id, label: items.name};
                                obj.children.push(newObj);
                            });
                            this.options.push(obj);
                        });
                    });
            },
            // 上传的事件
            handleRemove(file, fileList) {
                this.fileList = fileList;
            },
            uploadChange(file, fileList) {
                this.fileList = fileList;
            },
            handleExceed(file, fileList) {
                this.$message.warning('限制上传单个文件');
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let url = "";
                        // let obj2 = this.$refs[formName].$options.propsData.model;
                        let obj = {...this.ruleForm};
                        delete obj.value
                        if (this.fileList.length > 0) {
                            obj.fileName = this.fileList[0].name
                            obj.fileUrl = this.fileList[0].response.data
                        } else {
                            obj.fileName = ''
                            obj.fileUrl = ''
                        }
                        if (this.isAdd) {
                            addPromiseCard({...obj}).then(res => {
                                this.$message.success('添加成功')
                                this.$router.push({
                                    path: "/processManager/threeCard"
                                });
                            })
                        } else {
                            updatePromiseCard({...obj}).then(res => {
                                this.$message.success('添加成功')
                                this.$router.push({
                                    path: "/processManager/threeCard"
                                });
                            })
                        }
                    } else {
                        return false;
                    }
                });
            }
        },
        created() {
            this.getAllEmpInfo();
            let obj = this.$route.params.key;
            // console.log(obj)
            if (this.$route.params.key) {
                this.isAdd = false;
                this.getObj = obj;
                this.ruleForm = {
                    id: obj.id,
                    name: obj.name,
                    content: obj.content,
                    // value: [obj.departmentVo.id, obj.jobId],
                    commitmentDate: obj.commitmentDate,
                    number: obj.number,
                    empId: obj.empId,
                    depId: obj.departmentVo.id,
                    jobId: obj.jobId,
                    leaderEmpId: obj.leaderEmpId
                };
                if (obj.departmentVo) {
                    this.$set(this.ruleForm, "value", [obj.departmentVo.id, obj.jobId]);
                    // 获取部门领导
                    getDepartUser({demId: obj.departmentVo.id}).then(res => {
                        this.leaderEmpList = res.body.data;
                    });
                    // 获取岗位下面的人员
                    getEmpListByJobId({jobId: obj.jobId}).then(res => {
                        this.workerList = res.body.data
                        // this.ruleForm.empId = ''
                    })
                }
                if (obj.fileUrl) {
                    this.fileList.push({
                        name: obj.fileName,
                        response: {data: obj.fileUrl}
                    })
                }
            } else {
                this.ruleForm = {};
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    };
</script>

<style scoped>
    .addBtn {
        display: block;
        width: 300px;
        margin: 0 auto;
    }

    .myHead {
        position: absolute;
        top: 0px;
        left: 250px;
        width: 80%;
        height: 160px;
    }
</style>
